"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const SELECT_PROMPT = "\u2014";
const replaceOptions = (select, records) => {
  select.innerHTML = "";
  select.append(new Option(SELECT_PROMPT, ""));
  records.forEach(
    (record) => select.append(new Option(`${record.code} - ${record.name}`, record.id))
  );
  select.disabled = false;
};
const clearFollowing = (selects, index) => {
  selects.slice(index).forEach((select) => {
    replaceOptions(select, []);
    select.disabled = true;
  });
};
const setupGeography = (root) => {
  const levels = [
    "county",
    "constituency",
    "ward",
    "polling_station"
  ];
  const selects = levels.map(
    (level) => root.querySelector(`[data-kenya-level="${level}"]`)
  );
  if (selects.some((select) => !select)) {
    return;
  }
  const requests = [
    ["constituenciesUrl", "county_id"],
    ["wardsUrl", "constituency_id"],
    ["stationsUrl", "ward_id"]
  ];
  selects.slice(0, -1).forEach((select, index) => {
    select.addEventListener("change", () => __async(null, null, function* () {
      clearFollowing(selects, index + 1);
      if (!select.value) {
        return;
      }
      const [urlKey, parameter] = requests[index];
      const url = new URL(root.dataset[urlKey], window.location.origin);
      url.searchParams.set(parameter, select.value);
      const response = yield fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      });
      if (!response.ok) {
        return;
      }
      replaceOptions(selects[index + 1], yield response.json());
    }));
  });
};
const setupSavedProfile = (root) => {
  const checkbox = root.querySelector("[data-use-saved-profile]");
  const fields = root.querySelector("[data-participant-profile-fields]");
  const evidence = root.querySelector("[data-supporting-evidence]");
  const summary = root.querySelector("[data-saved-profile-summary]");
  if (!checkbox || !fields || !summary) {
    return;
  }
  const toggle = () => {
    const useSavedProfile = checkbox.checked;
    fields.hidden = useSavedProfile;
    if (evidence) {
      evidence.hidden = useSavedProfile;
    }
    summary.hidden = !useSavedProfile;
    checkbox.setAttribute("aria-expanded", String(useSavedProfile));
    [fields, evidence].filter(Boolean).forEach(
      (container) => container.querySelectorAll("input, select, textarea, button").forEach((control) => {
        if (useSavedProfile && !control.disabled) {
          control.disabled = true;
          control.dataset.disabledBySavedProfile = "true";
        } else if (!useSavedProfile && control.dataset.disabledBySavedProfile === "true") {
          control.disabled = false;
          Reflect.deleteProperty(control.dataset, "disabledBySavedProfile");
        }
      })
    );
  };
  checkbox.addEventListener("change", toggle);
  toggle();
};
const setupUppercaseInputs = (root) => {
  root.querySelectorAll("[data-uppercase-input]").forEach((input) => {
    input.addEventListener("input", () => {
      input.value = input.value.toUpperCase();
    });
  });
};
const setupVoterCardPicker = (root) => {
  const input = root.querySelector("[data-voter-card-input]");
  const status = root.querySelector("#kenyan-voter-card-status");
  const camera = root.querySelector("[data-voter-card-camera]");
  const preview = root.querySelector("[data-voter-card-camera-preview]");
  const canvas = root.querySelector("[data-voter-card-camera-canvas]");
  const captureButton = root.querySelector("[data-voter-card-camera-capture]");
  const cancelButton = root.querySelector("[data-voter-card-camera-cancel]");
  if (!input || !status) {
    return;
  }
  let mediaStream = null;
  const stopCamera = () => {
    mediaStream == null ? void 0 : mediaStream.getTracks().forEach((track) => track.stop());
    mediaStream = null;
    if (preview) {
      preview.pause();
      preview.srcObject = null;
    }
    if (camera) {
      camera.hidden = true;
    }
  };
  const openFilePicker = () => {
    input.accept = "image/jpeg,image/png,application/pdf";
    input.removeAttribute("capture");
    input.click();
  };
  const fallbackToFilePicker = (error) => {
    stopCamera();
    status.textContent = status.dataset.cameraFallbackLabel;
    console.warn(
      "[Kenyan voter] Camera unavailable; opening the file picker.",
      error
    );
    openFilePicker();
  };
  const openCamera = () => __async(null, null, function* () {
    var _a;
    status.textContent = status.dataset.cameraStartingLabel;
    if (!camera || !preview || !canvas || !captureButton || !cancelButton || !((_a = navigator.mediaDevices) == null ? void 0 : _a.getUserMedia)) {
      fallbackToFilePicker(
        new Error("MediaDevices.getUserMedia is unavailable")
      );
      return;
    }
    try {
      stopCamera();
      mediaStream = yield navigator.mediaDevices.getUserMedia({
        audio: false,
        video: { facingMode: { ideal: "environment" } }
      });
      preview.srcObject = mediaStream;
      camera.hidden = false;
      yield preview.play();
      status.textContent = status.dataset.cameraReadyLabel;
      captureButton.focus();
    } catch (error) {
      fallbackToFilePicker(error);
    }
  });
  root.querySelectorAll("[data-voter-card-action]").forEach((button) => {
    button.addEventListener("click", () => {
      if (button.dataset.voterCardAction === "camera") {
        openCamera();
      } else {
        stopCamera();
        openFilePicker();
      }
    });
  });
  captureButton == null ? void 0 : captureButton.addEventListener("click", () => {
    const width = preview.videoWidth;
    const height = preview.videoHeight;
    if (!width || !height) {
      fallbackToFilePicker(new Error("Camera returned no video frame"));
      return;
    }
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(preview, 0, 0, width, height);
    canvas.toBlob(
      (blob) => {
        if (!blob || typeof DataTransfer === "undefined") {
          fallbackToFilePicker(
            new Error("Captured photo could not be attached")
          );
          return;
        }
        const transfer = new DataTransfer();
        transfer.items.add(
          new File([blob], `voter-card-${Date.now()}.jpg`, {
            type: "image/jpeg"
          })
        );
        input.files = transfer.files;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        stopCamera();
        status.textContent = status.dataset.cameraCapturedLabel;
      },
      "image/jpeg",
      0.92
    );
  });
  cancelButton == null ? void 0 : cancelButton.addEventListener("click", () => {
    var _a, _b;
    stopCamera();
    status.textContent = ((_a = input.files) == null ? void 0 : _a.length) ? status.dataset.selectedTemplate.replace(
      "%{filename}",
      input.files[0].name
    ) : status.dataset.emptyLabel;
    (_b = root.querySelector('[data-voter-card-action="camera"]')) == null ? void 0 : _b.focus();
  });
  input.addEventListener("change", () => {
    var _a, _b;
    const filename = (_b = (_a = input.files) == null ? void 0 : _a[0]) == null ? void 0 : _b.name;
    status.textContent = filename ? status.dataset.selectedTemplate.replace("%{filename}", filename) : status.dataset.emptyLabel;
  });
  document.addEventListener("turbo:before-cache", stopCamera, { once: true });
  window.addEventListener("pagehide", stopCamera, { once: true });
};
const setupSignature = (root) => {
  var _a, _b, _c;
  const canvas = root.querySelector("[data-signature-canvas]");
  const output = root.querySelector("[data-signature-output]");
  if (!canvas || !output) {
    return;
  }
  const context = canvas.getContext("2d");
  const status = root.querySelector("#kenyan-signature-status");
  let drawing = false;
  let hasInk = false;
  let keyboardPoint = { horizontal: canvas.width / 2, vertical: canvas.height / 2 };
  context.lineWidth = 3;
  context.lineCap = "round";
  context.lineJoin = "round";
  context.strokeStyle = "#111827";
  const point = (event) => {
    const rectangle = canvas.getBoundingClientRect();
    return {
      horizontal: (event.clientX - rectangle.left) * (canvas.width / rectangle.width),
      vertical: (event.clientY - rectangle.top) * (canvas.height / rectangle.height)
    };
  };
  const begin = (event) => {
    drawing = true;
    const current = point(event);
    context.beginPath();
    context.moveTo(current.horizontal, current.vertical);
    canvas.setPointerCapture(event.pointerId);
  };
  const draw = (event) => {
    if (!drawing) {
      return;
    }
    const current = point(event);
    context.lineTo(current.horizontal, current.vertical);
    context.stroke();
    hasInk = true;
    status.textContent = "Signature drawn.";
  };
  const finish = () => {
    drawing = false;
    output.value = hasInk ? canvas.toDataURL("image/png") : "";
  };
  const clear = (message) => {
    context.clearRect(0, 0, canvas.width, canvas.height);
    output.value = "";
    hasInk = false;
    keyboardPoint = { horizontal: canvas.width / 2, vertical: canvas.height / 2 };
    status.textContent = message;
    canvas.focus();
  };
  canvas.addEventListener("pointerdown", begin);
  canvas.addEventListener("pointermove", draw);
  canvas.addEventListener("pointerup", finish);
  canvas.addEventListener("pointercancel", finish);
  canvas.addEventListener("keydown", (event) => {
    const movement = {
      ArrowLeft: [-8, 0],
      ArrowRight: [8, 0],
      ArrowUp: [0, -8],
      ArrowDown: [0, 8]
    }[event.key];
    if (!movement) {
      return;
    }
    event.preventDefault();
    const next = {
      horizontal: Math.max(0, Math.min(canvas.width, keyboardPoint.horizontal + movement[0])),
      vertical: Math.max(0, Math.min(canvas.height, keyboardPoint.vertical + movement[1]))
    };
    context.beginPath();
    context.moveTo(keyboardPoint.horizontal, keyboardPoint.vertical);
    context.lineTo(next.horizontal, next.vertical);
    context.stroke();
    keyboardPoint = next;
    hasInk = true;
    output.value = canvas.toDataURL("image/png");
    status.textContent = "Signature drawn.";
  });
  (_a = root.querySelector("[data-signature-clear]")) == null ? void 0 : _a.addEventListener("click", () => clear("Signature cleared."));
  (_b = root.querySelector("[data-signature-redraw]")) == null ? void 0 : _b.addEventListener(
    "click",
    () => clear("Canvas ready for a new signature.")
  );
  (_c = root.closest("form")) == null ? void 0 : _c.addEventListener("submit", () => {
    output.value = hasInk ? canvas.toDataURL("image/png") : "";
  });
};
const initializeKenyanVoterForms = () => {
  document.querySelectorAll("[data-kenyan-voter-form]").forEach((root) => {
    if (root.dataset.initialized === "true") {
      return;
    }
    root.dataset.initialized = "true";
    setupSavedProfile(root);
    setupUppercaseInputs(root);
    setupVoterCardPicker(root);
    setupGeography(root);
    setupSignature(root);
  });
};
document.addEventListener("DOMContentLoaded", initializeKenyanVoterForms);
document.addEventListener("turbo:load", initializeKenyanVoterForms);
